module.exports = __webpack_public_path__ + "img/fish.4f57f58e.png";